import axios from "axios";
import { getCookie , XSRFCOOKIE } from "@/lib/cookie";
import { CodiceFiscale} from "@/lib/codfisc";
import moment from "moment";
/**
 *
 * @param partner_code
 * @returns {Promise<unknown>}
 */
function verificaCodicePartner(partner_code){
    return new Promise((resolve,reject)=>{

        if( partner_code === '' || partner_code === null){
            resolve("ABORT");
        }else {
            let cookie = getCookie(XSRFCOOKIE);
            axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_CHECKCODICEPARTNER,
                {
                    codice: partner_code,
                }, {headers: {'X-CSRF-TOKEN': cookie}})
                .then((response) => {
                    if (response.data.status === "OK") {
                        resolve(response.data.partner)
                    } else {
                        resolve("NOTFOUND")
                    }
                }).catch((err)=>{
                    reject(err);
                });
        }
    });
}

/**
 *
 * @param compagniaid
 * @param numerovolo
 * @param datavolo
 * @returns {Promise<unknown>}
 */
function verificaTicketChiusiOK(compagniaid,numerovolo,datavolo){
   return new Promise((resolve,reject)=>
    {
        let cookie = getCookie(XSRFCOOKIE);
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_VERIFICA_CHIUSIOK,
            {
                numerovolo:numerovolo ,
                compagnia: compagniaid,
                datavolo: datavolo
            }, {headers: {'X-CSRF-TOKEN': cookie}}
        ).then(res => {
            if (res.data === 'TRUE') {
                resolve(true);
            }
            else { resolve(false); }
        }).catch((err)=>{ reject(err); })
    });
}

/**
 *
 * @param numerovolo
 * @param datavolo
 * @returns {Promise<unknown>}
 */
function verificaTicketEsistente(numerovolo,datavolo,email) {
    return new Promise((resolve,reject)=>{
        let cookie = getCookie(XSRFCOOKIE);
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_CHECKPRESENZA_STESSOTICKET,
            {
                email: email,
                numerovolo: numerovolo,
                datavolo:  datavolo
            },{headers:{'X-CSRF-TOKEN':cookie}}).then((response)=>{
            resolve(response.data);
        }).catch((err)=>{
            reject(err);
        })
    });
}

function verificaCodiceFiscale(value,nome,cognome){


        let outcome = false;
        if(value === null || value === undefined || value === '') return false;
        try {
            value = value.toUpperCase();

            if(nome === null || nome === undefined || nome === ''
                || cognome === null || cognome === undefined || cognome === ''
            ) return false;

            let nameCheck = new CodiceFiscale({
                name: nome.toUpperCase(),
                surname: cognome.toUpperCase(),
                gender: "M",
                day: 24,
                month: 7,
                year: 1980,
                birthplace: "Roma",
                birthplaceProvincia: "RM"
            });

            if( ! (nameCheck.code.substring(0,6).toUpperCase() === value.toUpperCase().substring(0,6) ) ) return false;

            outcome = CodiceFiscale.check(value.toUpperCase());

        }catch(err){
            outcome = false;
        }

        return outcome;
}


function verificaSeMinore(value){
    if(value === '' || value === undefined) return;


    try {
        let codfisc = new CodiceFiscale(value);
        let dnascita = moment(codfisc.birthday);
        console.log(dnascita);

        let anni = moment().diff(dnascita,'years');

        if(anni < 18) {
            return true;
        }else {
            return false;
        }

    }
    catch(err){
        console.log(err);
        return false;
    }
}

export { verificaCodicePartner , verificaTicketChiusiOK, verificaTicketEsistente, verificaCodiceFiscale, verificaSeMinore}